import Api from "./Api"

export const Login = async (payload) => Api().post(`auth/login`, payload)

export const send_otp = async (payload) => Api().post(`auth/send_otp`, payload)

export const verify_otp_update_password = async (payload) =>
  Api().post(`auth/verify_otp_update_password`, payload);

export const verify_auth = async (payload) =>
  Api().post(`auth/verify_auth`, payload);

export const GetUserProfile = async () => Api().get(`auth/get-profile`)

// For requesting the password reset link
export const forgotPassword = async (payload) => Api().post(`auth/forgot-password`, payload);

// For submitting the new password
export const resetPassword = async (payload) => Api().post(`auth/reset-password`, payload);